import { Popover } from 'antd';
import { UserContext } from 'contexts/ConfigContext';
import { useContext, useState } from 'react';
import { extractEmailAndName, getAuthUser, getConfig } from 'utils/helperMethods';
import UserAccountManager from './UserAccountManager';
import CustomAsperButton from 'components/atoms/CustomAsperButton';
import { useNavigate } from 'react-router-dom';
import MarketSelector from './MarketSelector';
import { BellOutlined } from '@ant-design/icons';

interface props {
    logOut: any;
}

export const Header = ({ logOut }: props) => {
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const showLogo = commonConfig?.showLogoInNavbar || false;
    const logoHeight = commonConfig?.logoHeight;
    const logoMaxWidth = commonConfig?.logoWidth;
    const fullName = extractEmailAndName();
    const userName = getAuthUser();
    const navigate = useNavigate();
    const [profileWindow, setProfileWindow] = useState(false);

    const content = () => {
        return (
            <div className="bg-white  min-w-[12rem] rounded-b-lg font-medium font-xs">
                <div className="text-purpleFont mb-2">{fullName}</div>
                <div
                    className="w-full py-1 mt-4 bg-purpleFont rounded flex justify-center items-center cursor-pointer"
                    onClick={() => logOut()}
                >
                    <span className="text-white">Logout</span>
                </div>
            </div>
        );
    };

    return (
        <header className="sticky top-0 z-50 w-full border-b bg-white">
            <div className="flex h-16 items-center justify-between px-4">
                {/* Left: Logo */}
                <div className="flex items-center flex-1">
                    {showLogo && (
                        <div className="global-filter-width mr-3">
                            <img
                                style={{ maxWidth: logoMaxWidth, height: logoHeight }}
                                src={require(`assets/images/${process.env.REACT_APP_TENANT_ID}_logo.png`)}
                            />
                        </div>
                    )}
                </div>

                {/* Center: Market Selector */}
                <div className="flex items-center justify-center flex-1">
                    <MarketSelector
                        onChange={(value: any) => {
                            console.log('Selected market:', value);
                        }}
                    />
                </div>

                {/* Right: Navigation */}
                <nav className="flex items-center gap-6 flex-1 justify-end">
                    {/* commented this one for demo purpose */}
                    {/* <Popover
                        overlayInnerStyle={{ position: 'relative', top: -5 }}
                        trigger={'hover'}
                        showArrow={false}
                        placement="bottomRight"
                        content={content}
                    >
                        <span
                            className="flex justify-center items-center rounded-full cursor-pointer bg-purple-100 avatar-size"
                            onClick={() => setProfileWindow((prev) => !prev)}
                        >
                            <span className="text-center text-purpleFont font-xxs font-bold">{userName}</span>
                        </span>
                    </Popover> */}

                    <CustomAsperButton
                        onClick={() => {
                            navigate('/ask-asper');
                        }}
                    />

                    <span
                        className={`flex justify-center items-center text-purpleFont hover:bg-bgBackground gap-x-7 p-1.5 rounded ${
                            location.pathname === '/alert' ? 'bg-bgBackground' : ''
                        }`}
                    >
                        <BellOutlined />
                    </span>
                    {/* Temporary component for demo purpose */}
                    <UserAccountManager
                        logOut={logOut}
                        avatarClassName="flex justify-center items-center rounded-full cursor-pointer bg-purple-100 avatar-size"
                        textClassName="text-center text-purpleFont font-xxs font-bold"
                    />
                </nav>
            </div>
        </header>
    );
};
